export default "__VITE_ASSET__D1mHzOp4__"